import { LOCALES, LOCALE_NAMES, type GuestLocale, type Locale } from "../lib/i18n.js";

/**
 * The guest's language switch.
 *
 * A native `<select>`, because it is the control every phone already knows how
 * to drive, and each option is labelled in its own language with a `lang`
 * attribute so a screen reader pronounces "Deutsch" as German. Changing it
 * re-renders in place: no reload, and the choice is remembered on the device.
 */
export function LanguagePicker({ locale, className = "" }: { locale: GuestLocale; className?: string }) {
  return (
    <label className={`lang-picker${className ? ` ${className}` : ""}`}>
      <span className="lang-picker-label">{locale.copy.languageLabel}</span>
      <select
        value={locale.lang}
        onChange={(event) => locale.setLang(event.target.value as Locale)}
        aria-label={locale.copy.languageLabel}
      >
        {LOCALES.map((code) => (
          <option key={code} value={code} lang={code}>
            {LOCALE_NAMES[code]}
          </option>
        ))}
      </select>
    </label>
  );
}
